// Generated types for RequirementUsage
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLUsageReadAPI, SysMLUsageWriteAPI } from './sysmlusage';
import { SysMLUsageReadAPISchemaObject, SysMLUsageWriteAPISchemaObject } from './sysmlusage';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface RequirementUsageReadAPI extends SysMLUsageReadAPI {
}

export interface RequirementUsageWriteAPI extends SysMLUsageWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const RequirementUsageReadAPISchema: z.ZodType<RequirementUsageReadAPI> = SysMLUsageReadAPISchemaObject.extend({}).passthrough();

export const RequirementUsageWriteAPISchema: z.ZodType<RequirementUsageWriteAPI> = SysMLUsageWriteAPISchemaObject.extend({}).passthrough();
